export const COMPOSE_ONLY_ATTACHMENT_CONTENT_START = 'owa-attachment-remove-on-send-start';
export const COMPOSE_ONLY_ATTACHMENT_CONTENT_END = 'owa-attachment-remove-on-send-end';

// The prefix must start with OLK to avoid CTS(content transformation service) from appending x_ in front.
export const OUTLOOK_BEAUTIFIED_PREFIX = 'OLK_Beautified_';

export const OUTLOOK_BEAUTIFUL_LINK_ATTRIBUTE = 'olkBeautifulLink';

export const OUTLOOK_BEAUTIFUL_LINK_ATTRIBUTE_VALUE = 'true';
